export default __webpack_public_path__ + "static/media/execute_LP.3df283f5.png";